import { renderContent, resetActiveFacets } from './replaceContent';

function activeFilters() {
  const activeFilters = document.querySelectorAll('#ActiveFiltersContainer a, .facets__header a');
  activeFilters.forEach((filter) => {
    filter.addEventListener('click', (e) => {
      e.preventDefault();

      const url = e.currentTarget.href.indexOf('?') == -1 ? '' : e.currentTarget.href.slice(e.currentTarget.href.indexOf('?') + 1);

      renderContent(url, e);

      const target = e.currentTarget.closest('.js-filter');
      resetActiveFacets(target);
    });
  });
}

export { activeFilters };
